const STORAGE_KEY = "slowedMemory";
const MAX_RECENTS = 6;
const LOCALSTORAGE_KEY = "slowed:slowedMemory";

const DEFAULT_MEMORY = {
  recents: [],
  likes: [],
  customMoods: [],
};

function hasChromeStorage() {
  try {
    return !!(self.chrome && self.chrome.storage && self.chrome.storage.local);
  } catch (_e) {
    return false;
  }
}

async function readRaw() {
  if (hasChromeStorage()) {
    return new Promise((resolve) => {
      self.chrome.storage.local.get([STORAGE_KEY], (data) => {
        resolve((data && data[STORAGE_KEY]) || null);
      });
    });
  }
  try {
    const raw = window.localStorage.getItem(LOCALSTORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (_e) {
    return null;
  }
}

async function writeRaw(memory) {
  if (hasChromeStorage()) {
    return new Promise((resolve) => {
      self.chrome.storage.local.set({ [STORAGE_KEY]: memory }, () => resolve());
    });
  }
  try {
    window.localStorage.setItem(LOCALSTORAGE_KEY, JSON.stringify(memory));
  } catch (_e) {
    /* ignore quota / sandbox errors */
  }
}

function normalize(memory) {
  if (!memory || typeof memory !== "object") return { ...DEFAULT_MEMORY };
  return {
    recents: Array.isArray(memory.recents) ? memory.recents.slice(0, MAX_RECENTS) : [],
    likes: Array.isArray(memory.likes) ? memory.likes : [],
    customMoods: Array.isArray(memory.customMoods) ? memory.customMoods : [],
  };
}

export async function getSlowedMemory() {
  return normalize(await readRaw());
}

export async function recordMoodUsed(name) {
  if (!name) return null;
  const memory = await getSlowedMemory();
  const next = [name, ...memory.recents.filter((n) => n !== name)].slice(
    0,
    MAX_RECENTS,
  );
  const updated = { ...memory, recents: next };
  await writeRaw(updated);
  return updated;
}

export async function toggleMoodLike(name) {
  if (!name) return null;
  const memory = await getSlowedMemory();
  const isLiked = memory.likes.includes(name);
  const likes = isLiked
    ? memory.likes.filter((n) => n !== name)
    : [...memory.likes, name];
  const updated = { ...memory, likes };
  await writeRaw(updated);
  return updated;
}

